export default __webpack_public_path__ + "static/media/Mustafa.470df4b7.webp";